import cardValidator from 'card-validator';
import { addMethod, StringSchema } from 'yup';

import { config } from 'data';

import { createError } from '../helpers';

addMethod(StringSchema, 'cardCode', function validate() {
  return this.trim()
    .min(config.CARD_CODE_MIN_LENGTH)
    .max(config.CARD_CODE_MAX_LENGTH)
    .test((value, context) => {
      if (!value) {
        return true;
      }

      const verification = cardValidator.cvv(value, [config.CARD_CODE_MIN_LENGTH, config.CARD_CODE_MAX_LENGTH]);

      if (verification.isValid) {
        return true;
      }

      return createError(context, 'cardCode');
    });
});
